export default "__VITE_ASSET__CeVHXDzT__"